import { Injectable } from '@angular/core';
import { IResponse, IUser } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { ISearch, IValidate } from 'projects/ui-components/src/interfaces/IUser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  constructor(
    private http_service: HttpService
  ) { }

  updateUser(values: IUser): Observable<IResponse<IUser>> {
    return this.http_service.post('persons/update', values)
  }

  createUser(values: IUser): Observable<IResponse<IUser>> {
    return this.http_service.post('users/create', values)
  };

  getUsers(org_id: number, search: string | null = null): Observable<IResponse<IUser[]>> {
    return this.http_service.post('users/get-by-org', {
      org_id: org_id,
      search
    })
  };

  searchForInvite(person_id: number, search_string: string): Observable<IResponse<{ content: ISearch[] }>> {
    return this.http_service.post('persons/search-for-invite', {
      person_id,
      search_string
    })
  };

  validateInviteEmail(org_id: number, email_address: string):
  Observable<IResponse<IValidate>> {
    return this.http_service.post('persons/validate-invite-email', {
      org_id,
      email_address
    })
  };
}